import { render, staticRenderFns } from "./StoreRatingOnGCIApp.vue?vue&type=template&id=879992cc"
import script from "./StoreRatingOnGCIApp.vue?vue&type=script&lang=js"
export * from "./StoreRatingOnGCIApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports